import { post } from '../utilities';
import { API_URL_PREFIX, DEFAULT_TOKEN } from '../utilities/constants';

export interface PromptVersionResponse {
    apiStatus: string;
    apiMessage: string;
    output: {
        jobId: string;
        template: {
            templateId: string;
            name: string;
            latestVersion: number;
            activeVersion: number;
        };
        versions: Array<{
            versionId: string;
            version: number;
            prompt: {
                system: string;
                userTemplate: string;
            };
            status: string;
            isActive: boolean;
            createdAt: number;
            changelog: string;
            experimentName?: string;
        }>;
    };
}

export interface CreatePromptVersionResponse {
    apiStatus: string;
    apiMessage: string;
    output: {
        versionId: string;
        templateId: string;
        jobId: string;
        version: number;
        prompt: {
            system: string;
            userTemplate: string;
        };
        changelog: string;
        status: string;
        experimentName: string;
        parentActiveVersionId: string | null;
        createdAt: number;
    };
}

export const getPromptVersions = (payload: {
    expertId: string;
    jobId: string;
    versionId?: string;
}) => {
    return post(`${API_URL_PREFIX}/V1/getPromptVersions`, { ...payload, token: DEFAULT_TOKEN });
};

export const updateActivePromptVersion = (payload: {
    expertId: string;
    jobId: string;
    versionId: string;
}) => {
    return post(`${API_URL_PREFIX}/V1/updateActivePromptVersion`, { ...payload, token: DEFAULT_TOKEN });
};

export const createPromptVersion = (payload: {
    expertId: string;
    jobId: string;
    prompt: {
        system: string;
        userTemplate: string;
    };
    changelog: string;
    status: 'DRAFT' | 'PUBLISHED';
    experimentName?: string;
    promptVersionId?: string;
}) => {
    return post(`${API_URL_PREFIX}/V1/createPromptVersion`, { ...payload, token: DEFAULT_TOKEN });
};

export const aiMatchingService = {
    getPromptVersions,
    updateActivePromptVersion,
    createPromptVersion,
};
